import styled from "styled-components";
import {Form, Input, Button} from 'global/styles/styles.js';

const S = {};

S.CashoutForm = styled(Form)`
    width: 100%;
    background-color: ${({theme: {$cashoutPanelBackgroundColor}}) => $cashoutPanelBackgroundColor};
`;

S.CashoutHeader = styled.div`
    height: 3rem;
    line-height: 3rem;
    border-bottom: 3px solid ${({theme: {$cashoutFormHeaderBorderColor}}) => $cashoutFormHeaderBorderColor};
    text-align: center;
    color: ${({theme: {$cashoutFormHeaderTextColor}}) => $cashoutFormHeaderTextColor};
    font-size: 16px;
    font-weight: bold;
`;

S.CashoutMainPanel = styled.div`
    padding: 1.5rem;
`;

S.CashoutAmountLabel = styled.div`
    margin-top: 0rem;
    margin-bottom: 1rem;
    color: ${({theme: {$cashoutFormMainTextColor}}) => $cashoutFormMainTextColor};
    font-size: 16px;
    font-weight: normal;
    text-align: center;
`;

S.CashoutSlider = styled.div`
    text-align: center;

    & .irs {
        & .irs {
            & .irs-line {
                background: ${({theme: {$cashoutSliderNotActiveColor}}) => $cashoutSliderNotActiveColor};
                border: 0px;
                height: 5px;
            }
            & .irs-single {
                display: none; 
            }
        }
        & .irs-grid {
            & .irs-grid-pol {
                background: ${({theme: {$cashoutSliderLabelColor}}) => $cashoutSliderLabelColor};
                transform: translate(0, -3rem);
                height: 12px;
                &.small {
                    top: 4px;
                    height: 5px;
                }
            }
            & .irs-grid-text {
                color: ${({theme: {$cashoutSliderLabelColor}}) => $cashoutSliderLabelColor};
                font-size: 12px;
                bottom: 6px;
            }
        }
        & .irs-slider {
            background: transparent;
            background-repeat: no-repeat;
            background-image: url(/images/svg/cashout-slider-handle.svg);
            background-size: 27px 27px;
            border: 0px;
            top: 23px;
        }
        & .irs-bar {
            background: ${({theme: {$cashoutSliderActiveColor}}) => $cashoutSliderActiveColor};
            border-top: 1px solid ${({theme: {$cashoutSliderActiveColor}}) => $cashoutSliderActiveColor};
            border-bottom: 1px solid ${({theme: {$cashoutSliderActiveColor}}) => $cashoutSliderActiveColor};
            height: 5px;
        }
        & .irs-bar-edge {
            border: 1px solid ${({theme: {$cashoutSliderActiveColor}}) => $cashoutSliderActiveColor};
            background: ${({theme: {$cashoutSliderActiveColor}}) => $cashoutSliderActiveColor};
            height: 5px;
        }
    }
`;

S.InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 4rem;
    margin-top: 1.33rem;
`;

S.CashoutStakeButton = styled(Button)`
    width: 3rem;
    height: 3rem;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${({theme: {$cashoutAmountButtonBackgroundColor}}) => $cashoutAmountButtonBackgroundColor};
    background-size: 1.5rem 1.5rem;
    border: 0px;

    &.decrement {
        border-radius: 8px 0px 0px 8px;
        background-image: url('/images/svg/cashout-stake-minus.svg');
        margin-right: 2px;
    }

    &.increment {
        border-radius: 0px 8px 8px 0px;
        background-image: url('/images/svg/cashout-stake-plus.svg');
        margin-left: 2px;
    }
`;

S.RowButtons = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 2.5rem;
    margin-bottom: 1.5rem;

    &.center {
        justify-content: center;
    }
`;

S.ActionButton = styled.div`
    border-radius: 25px;
    height: 50px;
    width: 46%;
    font-size: 16px;
    font-weight: bold;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    

    -webkit-box-shadow: 8px 8px 24px 0px rgba(9, 9, 10, 1);
    -moz-box-shadow: 8px 8px 24px 0px rgba(9, 9, 10, 1);
    box-shadow: 8px 8px 24px 0px rgba(9, 9, 10, 1);

    &.close-btn {
        background-color: #656565;
        color: #FFF;
    }

    &.cashout-now-btn {
        background-color: #019A39;
        color: #FFF;
    }

    &.cashout-success {
        background-color: #019A39;
        color: #FFF;
    }

    &.cashout-failed {
        background-color: #b13333;
        color: #FFF;
    }

    .center & {
        width: 80%;
    }
`;

S.CashoutStakeInput = styled(Input)`
    background-color: ${({theme: {$cashoutAmountInputBackgroundColor}}) => $cashoutAmountInputBackgroundColor};
    color: ${({theme: {$cashoutAmountInputColor}}) => $cashoutAmountInputColor};
    font-size: 18px;
    font-weight: bold;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    border-radius: 0px;
    border: 0px;
    padding: 0px;
    width: 80%;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &:focus{
        outline: none;
    }
    -moz-appearance: textfield;
`;

S.CashoutConfirmationPanel = styled.div`
    background-color:  ${({theme: {$cashoutCodePanelBackgroundColor}}) => $cashoutCodePanelBackgroundColor};
    width: 80%;
    margin: auto;
`;

S.CashoutConfirmationCodeInput = styled(Input)`
    background-color:  ${({theme: {$cashoutCodeInputBackgroundColor}}) => $cashoutCodeInputBackgroundColor};
    color: ${({theme: {$cashoutCodeInputTextColor}}) => $cashoutCodeInputTextColor};
    border: 1px solid ${({theme: {$cashoutCodeInputTextColor}}) => $cashoutCodeInputTextColor};
    height: 30px;
    width: 100%;
    margin-top: 1rem;
    &:focus{
        outline: none;
    }
`;

S.CashoutCodeButton = styled(Button)`
    color:  ${({theme: {$cashoutCodeButtonTextColor}}) => $cashoutCodeButtonTextColor};
    background-color: ${({theme: {$cashoutCodeButtonBackgroundColor}}) => $cashoutCodeButtonBackgroundColor};
    border-radius: 3px;
    width: 45%;
    height: 36px;
`;

S.CashoutMessagePanel = styled.div`
    padding: 1.5rem;
`;

S.CashoutStatusIcon = styled.div`
    width: 36px;
    height: 36px;
    background-repeat: no-repeat;
    margin: auto;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;

    &.cashout-success {
        background-image: url('/images/svg/cashout-success-icon.svg')
    }

    &.cashout-failed {
        background-image: url('/images/svg/cashout-failed-icon.svg')
    }
`;

S.CashoutHeaderMessage = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: ${({theme: {$cashoutConfirmTextMessageColor}}) => $cashoutConfirmTextMessageColor};
    text-align: center;
`;

S.CashoutMainMessage = styled.div`
    font-size: 13px;
    color: ${({theme: {$cashoutConfirmTextMessageColor}}) => $cashoutConfirmTextMessageColor};
    text-align: center;
    margin-top: 0.25rem;
    margin-bottom: 2rem;
`;




export default S;
